<template>
  <button
    type="button"
    class="bg-white text-font-dark rounded-md py-2 px-4 border border-font hover:text-font-darkest hover:border-font-dark"
  >
    <slot>
      Cancel
    </slot>
  </button>
</template>

<script>

</script>
